export default __webpack_public_path__ + "static/media/powerball_policy.f0fc1c26.png";